import { render, staticRenderFns } from "./EvaluationPerformancePhasePage.vue?vue&type=template&id=54d43bb2&"
import script from "./EvaluationPerformancePhasePage.vue?vue&type=script&lang=js&"
export * from "./EvaluationPerformancePhasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports